import React, { useState, useContext } from "react"
import { useParams } from 'react-router-dom';
import { Navbar, Nav, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faSearch } from '@fortawesome/free-solid-svg-icons'
import AdminStateContext, {states} from '../contexts/AdminStateContext';

function NavBar(_) {

    const { licenseName } = useParams();
    var [license] = useState(licenseName);

    const goHome = () => window.location = `/${license}/admin`;
    const [state, setState] = useContext(AdminStateContext);
        
    return (
        <Navbar>
            <Navbar.Brand>Agitura Portal</Navbar.Brand>
            <Nav className="mr-auto">
                <Button variant="dark" onClick={goHome}>
                    <FontAwesomeIcon icon={faHome} size="lg"></FontAwesomeIcon>
                    Startsida
                </Button>
                <Button style={{marginLeft:'10px'}} variant="dark" onClick={() => setState(states.SEARCH_PET)}>
                    <FontAwesomeIcon icon={faSearch} size="lg"></FontAwesomeIcon>
                    Sök djur
                </Button>
            </Nav>
        </Navbar>
    )
}

export default NavBar;